<div [class]="dynamicBannerClass" style="padding: 5px">
  <p style="color: black; text-align: center; margin-bottom: 0"><b>{{ header }}</b></p>
  <div style="color: black; text-align: center; margin-bottom: 0" [innerHTML]="message"></div>
</div>
